import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findShipmentProductList2DownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productList2Excel?` + params,
        method: 'GET'
    })
}

export const engineerShipment = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v2/engineer_shipment?` + params,
        method: 'GET'
    })
}